var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/native-promise-constructor.js
// module id = 205
// module chunks = 0 1 5 7 8 9 25